<template>
  <v-card flat>
    <v-toolbar dense flat dark color="primary" class="mb-0">
      <v-toolbar-title class="body-2">{{ formTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
      <v-btn x-small icon @click="close()">
        <v-icon>fa fa-close</v-icon>
      </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text class="px-3 py-2" >
      <v-row>
        <v-col cols=12 md=12 >
          <v-combobox
          v-model="frm.categorias"
          :items="categorias"
          item-text="categoria"
          item-value="categoriaID"
          label="Categorías"
          dense
          auto-select-first
          multiple
          small-chips
          clearable
          class="caption"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols=12 md=8 >
          <v-text-field dense v-model="frm.descripcion" label="Título" class="caption"></v-text-field>
        </v-col>
        <v-col cols=12 md=4 >
          <v-select
          v-model="frm.tipo"
          :items="tipos"
          label="Tipo"
          dense
          auto-select-first
          class="caption"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols=8>
          <v-text-field 
            label="Valor" 
            dense 
            class="caption" 
            v-model="editedItem.descripcion" 
            :disabled="!(frm.tipo=='MULTIPLE')" 
            clearable
          />
        </v-col>
        <v-col cols=1 class="text-center"  >
          <v-btn ref="add" x-small class="my-auto mx-0"	fab color="primary"	:disabled="!(frm.tipo=='MULTIPLE' && editedItem.descripcion && editedItem.descripcion.length)" @click="addItems">
            <v-icon dense>fa fa-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row cols=8 no-gutters="">
        <v-card tile  
          elevation=0 
          width="100%"
          class="pa-0 " 
          min-height="80px" 
          max-height="200px" 
          color="bg_gray" 
          :disabled="!(frm.tipo=='MULTIPLE')"
          style="overflow-y: auto"
        > 
          <v-list dense class="pa-0 ma-0" color="bg_gray" >
            <template v-for="(item, i) in frm.items">
            <v-list-item  :key="i" class="secondary lighten-5" >
              <v-list-item-content>
                <v-list-item-title  class="caption " :class="(item.id && item.remove)?'text-decoration-line-through':''">
                  {{item.descripcion}}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon color="primary" class="mx-2" @click="removeItems(item,i)">
                  <template v-if="item.remove">fa-check</template>
                  <template v-else>fa-close</template>
                </v-icon>
                <v-icon color="primary" class="mx-2" @click="editItems(item,i)" :disabled="item.remove">fa-pencil</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-divider :key="`divider_${i}`"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary darken-1" text @click="close">Cancelar</v-btn>
      <v-btn color="primary darken-1" text @click="save" :disabled="!flgSave">Guardar</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'Titulo',
    props:['id',''],

    components: {
      
    },

    data: () => ({
  
      items:[],
  
      tipos:['SIMPLE','LOGICO','MULTIPLE'],

      categorias:[],

      valor:"",

      default:{
        id:0,
        tipo:"SIMPLE",
        descripcion:"",
        estado:true,
        items:[],
        categorias:[]
      },
      frm:{},

      editedIndex: -1,
      editedItem :{id:0,descripcion:""}

    }),
    created: function () {
      console.log("Componente creado")
     /* if (this.id)*/ this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
      //this.loadItems()
    },
    watch: {
    },

    methods: {
      async initialize () {

        let response
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        

        //INI FORMULARIO
        //INI CATEGORIA
        response = await fetch(`${this.ROOT_API}categorias`, opt);
        if (response.ok){
          let r=await response.json()
          this.categorias=r.map(item => {
            return {
              categoriaID:item.id,
              categoria:item.categoria 
            }
          })
        }
        //FIN CATEGORIA
        
        //FIN FORMULARIO




        //INI GRAL
        response = await fetch(`${this.ROOT_API}titulos/${this.id}`, opt);

        this.frm=Object.assign({},this.default)

        if (response.ok){
          let r=await response.json()

          if (r.length) {
             this.frm={
               id:r[0].id,
               descripcion:r[0].descripcion,
               tipo:r[0].tipo,
               categorias:r[0].categorias,
               items:r[0].items?r[0].items.map(i => {let r=i; r.remove=false; return r }):[]
             }
          }
        }
        //FIN GRAL

      },

      editItems (item,i){

        console.log("item --> ",item)
        console.log("i --> ", i)
        Object.assign(this.editedItem, item)
        this.editedIndex=i

        
      },

      addItems (){

        if (this.editedIndex==-1){
          console.log("nuevo item")
          this.frm.items.push(this.editedItem)
        }
        else {
          console.log("edit item")
          Object.assign(this.frm.items[this.editedIndex],this.editedItem)
        }

        this.editedItem={id:0,descripcion:""}
        this.editedIndex=-1

      },



      removeItems (item, i) {
        //console.log(item)

        if (item.id && item.remove!==undefined){
          item.remove=!item.remove
          Object.assign(this.frm.items[i], item)
        }
        else {
          this.frm.items.splice(i,1)
        }

        console.log(this.frm.items[i])
      },

      close () {
        this.frm=Object.assign({},this.default)
        this.$emit('close')
      },

      async save () {

        console.log("id --> ",this.id)
        console.log("frm --> ",this.frm )

        let response

        if (this.id==0){
          //NUEVO
          let opt={
            method: 'POST', 
            mode: 'cors',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },  
            body: JSON.stringify(this.frm)
          }
          response = await fetch(`${this.ROOT_API}cms/titulos`, opt)

        }
        else {
          //EDITAR
          console.log("UPDATEEEEE")
          let opt={
            method: 'PUT', 
            mode: 'cors',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },  
            body: JSON.stringify(this.frm)
          }
          response = await fetch(`${this.ROOT_API}cms/titulos/${this.id}`, opt)
        }

        this.$emit("reload")

        this.close()
      },



      async loadItems (){
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        let response = await fetch(`${this.ROOT_API}titulos`, opt);

        if (response.ok){
          let r=await response.json()
          this.items=r.map(item => {
            return {
              id:item.id,
              codigo:item.codigo,
              des:item.des,
              precio:item.precio,

              marca:'',//item.marca
              categoria:''
            }
          })
        }

      }


    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      formTitle () {
        return this.id === 0 ? 'Nuevo Dato Técnico' : 'Editar Dato Técnico'
      },

      flgSave () {
        return (this.frm.descripcion && this.frm.descripcion.length>0) ? true : false
        //this.editedItem.descripcion
        //this.editedItem.tipo
      }

    },
  }
</script>

<style scoped>

</style>
